// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workingTemplateCard {
  background: #ffffff;
  border-radius: 16px;
  min-width: 529px;
  width: 36.73vw;
  display: flex;
  flex-direction: column;
  height: 165px;
  margin: 9px;
  padding: 24px;
}
.workingTemplateCard .container {
  text-align: left;
}
.workingTemplateCard .headerRow {
  display: flex;
  align-content: space-between;
}
.workingTemplateCard .headerRow .titleContainer {
  display: flex;
}
.workingTemplateCard .headerRow .titleContainer .image {
  display: inline-block;
}
.workingTemplateCard .headerRow .titleContainer .text {
  display: inline-block;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
  position: relative;
  bottom: 7px;
  left: 2px;
}
.workingTemplateCard .headerRow .dropDown {
  margin-left: auto;
}
.workingTemplateCard .dataContainer {
  text-align: left;
  margin-top: 17px;
}
.workingTemplateCard .dataContainer .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  display: inline-block;
}
.workingTemplateCard .dataContainer .data {
  display: inline-block;
  margin-left: 24px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.workingTemplateCard .payCard {
  padding: 2px 6px;
  gap: 10px;
  background: #ece1f6;
  border-radius: 4px;
  color: #4b3563;
  display: inline-block;
}
.workingTemplateCard .weekly {
  background: #fdd8c3;
  color: #863f17;
}
.workingTemplateCard .monthly {
  background: #fde9c3;
  color: #4e3d2e;
}
.workingTemplateCard .amount {
  display: inline-block;
  margin-left: 10px;
}

.popup-content {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.popup-content .templateCardPopupContentMenuItem {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-bottom: 6px;
}

.popup-content {
  margin: auto;
  width: 50%;
  padding: 5px;
  background: #ffffff;
  border: 1px solid #e9e9e9 !important;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06) !important;
}

.templateCardPopupContentMenuItem:hover {
  background-color: white !important;
  color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/screens/workingTemplate/templateCard/templateCard.scss"],"names":[],"mappings":"AAAA;EAEI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;AADJ;AAGI;EACI,gBAAA;AADR;AAII;EACI,aAAA;EACA,4BAAA;AAFR;AAGQ;EACI,aAAA;AADZ;AAEY;EACI,qBAAA;AAAhB;AAEY;EACI,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAAhB;AAGQ;EACI,iBAAA;AADZ;AAII;EACI,gBAAA;EACA,gBAAA;AAFR;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AADZ;AAGQ;EACI,qBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAKI;EACI,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAHR;AAKI;EACI,mBAAA;EACA,cAAA;AAHR;AAMI;EACI,mBAAA;EACA,cAAA;AAJR;AAMI;EACI,qBAAA;EACA,iBAAA;AAJR;;AAQA;EACI,mBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;EACA,4CAAA;EACA,kBAAA;AALJ;AAOI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AALR;;AAQA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,uDAAA;AALJ;;AAQA;EACI,kCAAA;EACA,uBAAA;AALJ","sourcesContent":[".workingTemplateCard {\n    // background: #ffffff;\n    background: #ffffff;\n    border-radius: 16px;\n    min-width: 529px;\n    width: 36.73vw;\n\n    display: flex;\n    flex-direction: column;\n    height: 165px;\n    margin: 9px;\n    padding: 24px;\n\n    .container {\n        text-align: left;\n    }\n\n    .headerRow {\n        display: flex;\n        align-content: space-between;\n        .titleContainer {\n            display: flex;\n            .image {\n                display: inline-block;\n            }\n            .text {\n                display: inline-block;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 500;\n                font-size: 18px;\n                line-height: 24px;\n                color: #333333;\n                position: relative;\n                bottom: 7px;\n                left: 2px;\n            }\n        }\n        .dropDown {\n            margin-left: auto;\n        }\n    }\n    .dataContainer {\n        text-align: left;\n        margin-top: 17px;\n        .header {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n            display: inline-block;\n        }\n        .data {\n            display: inline-block;\n            margin-left: 24px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n\n    .payCard {\n        padding: 2px 6px;\n        gap: 10px;\n        background: #ece1f6;\n        border-radius: 4px;\n        color: #4b3563;\n        display: inline-block;\n    }\n    .weekly {\n        background: #fdd8c3;\n        color: #863f17;\n    }\n\n    .monthly {\n        background: #fde9c3;\n        color: #4e3d2e;\n    }\n    .amount {\n        display: inline-block;\n        margin-left: 10px;\n    }\n}\n\n.popup-content {\n    background: #ffffff;\n    border: 1px solid #e9e9e9;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    border-radius: 8px;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    border-radius: 8px;\n\n    .templateCardPopupContentMenuItem {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n        color: #333333;\n        cursor: pointer;\n        padding-bottom: 6px;\n    }\n}\n.popup-content {\n    margin: auto;\n    width: 50%;\n    padding: 5px;\n    background: #ffffff;\n    border: 1px solid #e9e9e9!important;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06)!important;\n}\n \n.templateCardPopupContentMenuItem:hover {\n    background-color: white !important;\n    color: black !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
